<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党建宣传</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<el-input
							placeholder="请输入内容"
							prefix-icon="el-icon-search"
							style="width: 200px;"
							size="small"
							v-model="getdata.title"
							@input="getdata.page = 1;totalPage = 0;dataList();">
						</el-input>
						<div v-if="$store.state.user.userinfo.flag==1">
							<el-button type="primary" size="small" @click="addZx">新增</el-button>
							<el-button type="primary" size="small" @click="delAll">一键删除</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							@selectList="selectList"
                            :tableHeader="tableHeader"
                            :loading="true" 
							:indexs="false"
							:selection="true"></myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tree from '@/components/tree.vue'
	import { djxc } from '@/axios'
	import Page from '@/components/page.vue'
	import DelData from '@/components/delToast.vue'
	import { Message } from 'element-ui'
	import myTables from '@/components/tables/tables.vue'
	let that;
	export default{
		data(){
			return{
				getdata:{
					id:this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					page:1,
					title:""
				},
				delList:[],
				tableData:[],
				totalPage:0
			}
		},
		components:{tree,Page,DelData,myTables},
		created(){that = this},
		computed:{
			tableHeader(){
				let contralBar = {
					prop: 'oper', label: '操作', fixed: 'right', width: '120',
				};
				let  tableHeader = [     // 表头
					{prop: 'sz_img', label: '封面',width:"180"},
					{prop: 'title', label: '标题',width:""},
					{prop: 'pub_user', label: '发布人',width:"160"},
					// 如果后端传过来的值不是我们所预期的，此处可以如下判断修改，isok是是否需要渲染为el-tag,效果为下图
					{prop: 'pub_time', label: '发布时间',width:"110",formatData:(val) => {
						return this.$changeTime(val)
					}},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
				];
				if(this.$store.state.user.userinfo.flag==1){
					contralBar = {
						...contralBar,
						oper: [
							{name: '详情', style: {color:'#bb0000'}, clickFun: this.showDetail},
							{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit},
							{name: '删除', style: {color:'#bb0000'}, clickFun: this.del},
						]
					}
				}else{
					contralBar = {
						...contralBar,
						oper: [
							{name: '详情', style: {color:'#bb0000'}, clickFun: this.showDetail},
						]
					}
				}
				tableHeader.push(contralBar)
				return tableHeader
			}
		},
		mounted() {
			that.dataList();
		},
		methods:{
			// 数据
			dataList(){
				djxc.zbNews(that.getdata).then(res => {
					that.tableData = res.data.pagedata;
					that.totalPage = res.data.count;
				})
			},
			// 详情
			showDetail(data){
				that.$router.push({
					path:"/ywzx_detail",
					query:{
						flag:data.flag,
						id:data.id
					}
				})
			},
			// 编辑
			edit(data){
				that.$router.push({
					path:"/ywzx_add",
					query:{
						id:data.id,
						flag:data.flag,
						type:'edit'
					}
				})
			},
			// 新增资讯
			addZx(){
				that.$router.push({
					path:'/ywzx_add',
					query:{
						uid:that.getdata.id,
						type:'add',
						flag:that.getdata.flag
					},
				})
			},
			// 一键删除
			selectList(value){
				that.delList =value;
			},
			delAll(){
				if(that.delList.length == 0){
					Message.warning('请先选择要删除得数据')
				}else{
					that.delData();
				}
			},
			//	删除操作
			delData(){
				that.$refs.delDatas.showToast(res => {
					if(res){
						djxc.zbNewsDel({
							id:that.delList,
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			},
			// 删除
			del(data){
				that.delList = [];
				that.delList = [data.id];
				that.delData();
			},
			// 树形结构筛选
			treeSelect(data){
				that.getdata.id = data.id;
				that.getdata.flag = data.flag;
				that.getdata.page = 1;
				that.dataList();
			},
			// 分页筛选
			changedata(curret){
				that.getdata.page = curret;
				that.dataList();
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 150px;
			object-fit: cover;
		}
	}
</style>

